import React from 'react';
import { AiFillLock, AiOutlineStar } from 'react-icons/ai';
import { MdOutlineGppGood, MdOutlinePrivacyTip, MdOutlineSupportAgent, MdSecurity } from 'react-icons/md';
import { TbAsteriskSimple } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import whyjoin from '../../assets/img/why-join.png';
import protection from '../../assets/img/protection.png';
import taskdeapp from '../../assets/img/taskde-app.png';
import appstore from '../../assets/img/app-store.png';
import playstore from '../../assets/img/google-play.png';
import Banner from '../Home/Banner';
import Values from '../Home/Values';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import { fadeInLeft, fadeInRight } from 'react-animations';
import Radium, { StyleRoot } from 'radium';
import { useEffect } from 'react';
import { getTaskCategoryList } from '../../Redux/Task/action';
import { useState } from 'react';
import { RiHandCoinLine } from 'react-icons/ri';

const styles = {
    fadeInLeft: {
        animation: 'x 3s',
        animationName: Radium.keyframes(fadeInLeft, 'fadeInLeft')
    },
    fadeInRight: {
        animation: 'x 3s',
        animationName: Radium.keyframes(fadeInRight, 'fadeInRight')
    }
}


const BecomeSeller = () => {
    const [category, setCategory] = useState();
    useEffect(() => {
        getTaskCategoryList()((response) => {
            if (response && response.status) {
                setCategory(response?.data?.data)
            }


        });
    }, []);

    const [showMore, setShowMore] = useState(false);

    const toggleShowMore = () => {
        setShowMore(!showMore);
    };
    return (
        <React.Fragment>
            <StyleRoot>
                <Header />
                <Banner categories={category} />
                <Values />
                <section className='why-join'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                                <div className='why-join-title'>
                                    <h3>Why Join Taskde ?</h3>
                                    <p>Here are few great reasons</p>
                                </div>
                                <div className='why-join-desc'>
                                    <div>
                                        <div className='why-join-desc-input'>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill='#264796'><path d="M20,3.59H16.75V2.66a.75.75,0,1,0-1.5,0v.93H8.75V2.66a.75.75,0,1,0-1.5,0v.93H4A2.75,2.75,0,0,0,1.25,6.34v13A2.75,2.75,0,0,0,4,22.09H20a2.75,2.75,0,0,0,2.75-2.75v-13A2.75,2.75,0,0,0,20,3.59ZM4,5.09H7.25V6.16a.75.75,0,0,0,1.5,0V5.09h6.5V6.16a.75.75,0,0,0,1.5,0V5.09H20a1.25,1.25,0,0,1,1.25,1.25V8.59H2.75V6.34A1.25,1.25,0,0,1,4,5.09ZM21.25,19.34A1.25,1.25,0,0,1,20,20.59H4a1.25,1.25,0,0,1-1.25-1.25V10.09h18.5Z"></path><path d="M8,16.84a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,8,16.84Zm0-3.5a1,1,0,1,1-1,1A1,1,0,0,1,8,13.34Z"></path></svg>
                                            <h3 className='ms-2'>Diverse Offerings</h3>
                                        </div>
                                        <p>Gain access to a rich tapestry of services, from specialized astrology insights to transformative healing sessions, tailored to cater to your unique needs and aspirations.</p>
                                    </div>
                                    <div>
                                        <div className='why-join-desc-input'>
                                            <MdSecurity fill='#264796' style={{ width: '24px', height: '24px' }} />
                                            <h3 className='ms-2'>Expert Guidance</h3>
                                        </div>
                                        <p>Connect with a community of seasoned professionals committed to delivering exceptional results and fostering your personal and professional growth.</p>
                                    </div>
                                    <div>
                                        <div className='why-join-desc-input'>
                                            <TbAsteriskSimple fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                            <h3 className='ms-2'>Seamless Experience</h3>
                                        </div>
                                        <p>Enjoy a user-friendly interface and streamlined processes, ensuring a hassle-free journey from discovery to completion of services.</p>
                                    </div>
                                    <div>
                                        <div className='why-join-desc-input'>
                                            <AiFillLock fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                            <h3 className='ms-2'>Secure Transactions</h3>
                                        </div>
                                        <p>Rest assured that all transactions are secure and reliable, providing you with peace of mind and fostering a trustworthy environment.</p>
                                    </div>

                                    {showMore && (
                                        <>
                                            <div>
                                                <div className='why-join-desc-input'>
                                                    <MdOutlineSupportAgent fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                                    <h3 className='ms-2'>Community Support</h3>
                                                </div>
                                                <p>Join a supportive and vibrant community that values collaboration, growth, and mutual success, fostering an environment where your voice is heard and your goals are supported.
                                                </p>
                                            </div>
                                            <div>
                                                <div className='why-join-desc-input'>
                                                    <MdOutlineGppGood fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                                    <h3 className='ms-2'>Elevated Well-being </h3>
                                                </div>
                                                <p>Experience an array of offerings dedicated to enhancing your overall well-being, making your journey towards self-improvement and success as smooth and impactful as possible.</p>
                                            </div>
                                            <div>
                                                <div className='why-join-desc-input'>
                                                    <RiHandCoinLine fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                                    <h3 className='ms-2'>Lucrative Earnings</h3>
                                                </div>
                                                <p>Leverage our platform to maximize your earnings, with a fair and transparent system that ensures you are duly rewarded for your expertise and efforts.
                                                </p>
                                            </div>
                                        </>
                                    )}
                                    <div className='show-more-wrapper'>
                                        <button onClick={toggleShowMore} className='show-more-less'>
                                            {showMore ? 'Show Less -' : 'Show More +'}
                                        </button>
                                    </div>
                                </div>
                                <div className='why-join-btn'>
                                    <Link className="becometasker scrollto" to="/signup">Join Taskde</Link>
                                </div>
                            </div>
                            <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                                <div className='why-join-img'>
                                    <img src={whyjoin} className='img-fluid' alt='' />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='protection'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-lg-7 col-md-7 col-sm-12 col-12' style={styles.fadeInLeft}>
                                <div className='protection-img'>
                                    <img src={protection} className='img-fluid' alt='' />
                                </div>
                            </div>
                            <div className='col-lg-5 col-md-5 col-sm-12 col-12' style={styles.fadeInRight}>
                                <div className='protection-title'>
                                    <h3>Protection</h3>
                                    <p>It’s nice to have a safety net - that’s why we’ve got insurance available to help you do tasks with peace of mind.</p>
                                </div>
                                <div className='protection-desc'>
                                    <div className='protection-desc-input'>
                                        <MdOutlinePrivacyTip fill='#264796' style={{ width: '24px', height: '24px' }} />
                                        <h3 className='ms-2'>Public Liability*</h3>
                                    </div>
                                    <p>Taskde Insurance covers the Tasker for their liability to third parties for personal injury or property damage whilst performing certain task activities</p>
                                    <div className='protection-desc-input'>
                                        <AiOutlineStar fill='#264796' style={{ width: '24px', height: '24px' }} />
                                        <h3 className='ms-2'>Top rated insurance</h3>
                                    </div>
                                    <p>Taskde Insurance is provided by Berkshire Hathaway Specialty Insurance - one of the most reputable and innovative insurance brands</p>
                                    <div className='protection-terms'>
                                        <p>*subject to terms and conditions, excess and exclusions applies.</p>
                                    </div>
                                </div>
                                <div className='protection-btn'>
                                    <Link className="becometasker scrollto" to="/">Learn more</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <div className='container'>
                        <div className='app-download'>
                            <div className="row gy-4">

                                <div className="col-lg-6 order-2 order-lg-1" style={styles.fadeInRight}>
                                    <div className="content">
                                        <div className="container-inner mt-5">
                                            <div className="list column-2 text-description">
                                                <h3 className="blue">On the move?</h3>
                                                <p>Download the Taskde App and get the tasks you need completed with just a tap of the button. You can also browse available tasks and earn money wherever you go!</p>

                                            </div>
                                            <div className="list column-2 smart-phones">
                                                <h3 className='seller_fs'>For Seller</h3>
                                                <div className='link_flex'>
                                                    <Link to='https://apps.apple.com/us/app/taskde-seller-app/id6445817925' target='_blank'>
                                                        <img alt="" src={appstore} className='img-fluid' />
                                                    </Link>
                                                    <Link to='https://play.google.com/store/apps/details?id=com.taskde.taskdeseller' target='_blank'>
                                                        <img alt="" src={playstore} className='img-fluid' />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="list column-2 smart-phones">
                                                <h3 className='buyer_fs'>For Buyer</h3>
                                                <div className='link_flex'>
                                                    <Link to='https://apps.apple.com/in/app/taskde-buyer-app/id6445815247' target='_blank'>
                                                        <img alt="" src={appstore} className='img-fluid' />
                                                    </Link>
                                                    <Link to='https://play.google.com/store/apps/details?id=com.taskde.taskdebuyer' target='_blank'>
                                                        <img alt="" src={playstore} className='img-fluid' />
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-6' style={styles.fadeInLeft}>
                                    <div className="apps-badges">
                                        <img alt="" src={taskdeapp} className='img-fluid' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* <section id="faq" className="faq">
                    <div className="container-fluid" >

                        <div className="row gy-4">

                            <div className="col-lg-12 d-flex flex-column justify-content-center align-items-stretch  order-2 order-lg-1">

                                <div className="content px-xl-5 mb-5">
                                    <h3>FAQ</h3>
                                </div>

                                <div className="accordion accordion-flush px-xl-5" id="faqlist">
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <div className="accordion-item" >
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-1">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Non consectetur a erat nam at lectus urna duis?
                                                    </button>
                                                </h3>
                                                <div id="faq-content-1" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                    <div className="accordion-body">
                                                        Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='col-lg-6'>
                                            <div className="accordion-item" >
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-2">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Non consectetur a erat nam at lectus urna duis?
                                                    </button>
                                                </h3>
                                                <div id="faq-content-2" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                    <div className="accordion-body">
                                                        Feugiat pretium nibh ipsum consequat. Tempus iaculis urna id volutpat lacus laoreet non curabitur gravida. Venenatis lectus magna fringilla urna porttitor rhoncus dolor purus non.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <div className="accordion-item" >
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-3">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Feugiat scelerisque varius morbi enim nunc faucibus a pellentesque?
                                                    </button>
                                                </h3>
                                                <div id="faq-content-3" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                    <div className="accordion-body">
                                                        Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div className='col-lg-6'>
                                            <div className="accordion-item" >
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-4">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi?
                                                    </button>
                                                </h3>
                                                <div id="faq-content-4" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                    <div className="accordion-body">
                                                        Eleifend mi in nulla posuere sollicitudin aliquam ultrices sagittis orci. Faucibus pulvinar elementum integer enim. Sem nulla pharetra diam sit amet nisl suscipit. Rutrum tellus pellentesque eu tincidunt. Lectus urna duis convallis convallis tellus. Urna molestie at elementum eu facilisis sed odio morbi quis
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-lg-6'>
                                            <div className="accordion-item" >
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-5">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Ac odio tempor orci dapibus. Aliquam eleifend mi in nulla?
                                                    </button>
                                                </h3>
                                                <div id="faq-content-5" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                    <div className="accordion-body">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Dolor sit amet consectetur adipiscing elit pellentesque habitant morbi. Id interdum velit laoreet id donec ultrices. Fringilla phasellus faucibus scelerisque eleifend donec pretium. Est pellentesque elit ullamcorper dignissim. Mauris ultrices eros in cursus turpis massa tincidunt dui.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='col-lg-6'>
                                            <div className="accordion-item" >
                                                <h3 className="accordion-header">
                                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-6">
                                                        <i className="bi bi-question-circle question-icon"></i>
                                                        Tempus quam pellentesque nec nam aliquam sem et tortor consequat?
                                                    </button>
                                                </h3>
                                                <div id="faq-content-6" className="accordion-collapse collapse" data-bs-parent="#faqlist">
                                                    <div className="accordion-body">
                                                        Molestie a iaculis at erat pellentesque adipiscing commodo. Dignissim suspendisse in est ante in. Nunc vel risus commodo viverra maecenas accumsan. Sit amet nisl suscipit adipiscing bibendum est. Purus gravida quis blandit turpis cursus in
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>


                        </div>

                    </div>
                </section> */}
                <Footer />
            </StyleRoot>
        </React.Fragment>
    )
}

export default BecomeSeller;